import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import CreateCourse from "./createCourse";
import CapCourseTable from "./capCourseTable";
import AddCapCourse from "./addCapCourse";
import AddCapverifier from "../capVerifier/addCapVerifier";

export default function Index() {
  const naviagte = useNavigate();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");

  // const [course, setCourse] = useState("capcourselist");

  // useEffect(() => {
  //   setCourse(page);
  // }, [page]);

  return (
    <Grid
      p={page === "capcourselist" ? "none" : 3}
      sx={{
        minHeight: "50vh",
        backgroundColor:
          page === "capcourselist"  ? "none" : "#fff",
        borderRadius: "8px",
      }}
    >
      {page === "capcourselist" && (
        <Grid container>
          <Grid
            item
            md={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <MauvelousPrimaryButton
              title={"Add cap Course"}
              handleClick={() =>
                naviagte(
                  `/${Cookies.get(
                    "mhet_mst_project"
                  )}/cap-course-management?page=addcapcourse`
                )   
              }
            />
          </Grid>
          <Grid item md={12}>
            <CapCourseTable />
          </Grid>
        </Grid>
      )} 
      {page === "addcapcourse" && <AddCapCourse />}
      {page === "createcourse" && <CreateCourse />}
      {page === "updatecapcourse" && <AddCapCourse />}
      {page === "createcapverifier" && <AddCapverifier />}
    </Grid>
  );
}
